/**
 * @generated SignedSource<<3b1b9fb1b27a0262b3697c1375e19322>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountExtensionKind = "Academies";
export type Kind = "Assigment" | "FreeForAll";
export type licenseDetails_Query$variables = {
  licenseGroupingId: string;
};
export type licenseDetails_Query$data = {
  readonly AccountMemberManagement: {
    readonly UserInAccountGroupWrappers: {
      readonly count: any;
      readonly userInAccountGroupWrappers: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly group: {
              readonly id: string;
              readonly isBuiltIn: boolean;
              readonly name: string;
            };
            readonly memberCount: any;
          };
        } | null> | null;
      };
    };
  };
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly accounts: ReadonlyArray<{
          readonly extension: {
            readonly kind: AccountExtensionKind;
            readonly licenseModelKind?: Kind | null;
          } | null;
          readonly id: string;
        }>;
      } | null;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"licenseDetails_LicenseGroupingFragment" | "licensesNewSingleUserAssignmentForm_QueryFragment" | "userRulesTab_UserQueryFragment">;
};
export type licenseDetails_Query = {
  response: licenseDetails_Query$data;
  variables: licenseDetails_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "licenseGroupingId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "doCalcMemberCount",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "includeOwner",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "includeUser",
    "value": true
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isBuiltIn",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UserInAccountGroup",
  "kind": "LinkedField",
  "name": "group",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v9 = [
  {
    "kind": "Literal",
    "name": "accountExtensionKind",
    "value": "Academies"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "licenseModelKind",
      "storageKey": null
    }
  ],
  "type": "AcademiesAccountExtension",
  "abstractKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "licenseGroupingId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "ContractPartner",
  "kind": "LinkedField",
  "name": "contractPartner",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContractPartnerData",
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkToAGB",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CoachingOfferDescription",
    "kind": "LinkedField",
    "name": "description",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "storageKey": null
  }
],
v18 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnOpportunityV2",
    "kind": "LinkedField",
    "name": "root",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v14/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "structureDefinition",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "extension",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*: any*/)
                            ],
                            "type": "PublishedConstellationRootExtensionExtension",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PublishedRootExtensionImpl",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LearnOpportunityRootStructureDefinition",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v16/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "licenseDetails_Query",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "licenseGroupingId",
            "variableName": "licenseGroupingId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "licenseDetails_LicenseGroupingFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "licensesNewSingleUserAssignmentForm_QueryFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "userRulesTab_UserQueryFragment"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountMemberManagementQueries",
        "kind": "LinkedField",
        "name": "AccountMemberManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "UserInAccountGroupWrappersResult",
            "kind": "LinkedField",
            "name": "UserInAccountGroupWrappers",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInAccountGroupWrapperConnection",
                "kind": "LinkedField",
                "name": "userInAccountGroupWrappers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserInAccountGroupWrapperEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInAccountGroupWrapper",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "UserInAccountGroupWrappers(doCalcMemberCount:false,includeOwner:true,includeUser:true)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "accounts",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": (v9/*: any*/),
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": "extension(accountExtensionKind:\"Academies\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "licenseDetails_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LicenseGroupingQueries",
        "kind": "LinkedField",
        "name": "LicenseGrouping",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "licenseGroupingId"
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "LicenseGrouping",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usedLicenseAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalLicenseAmount",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isLicenseGrouping"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "assignmentRules",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "active",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountRef",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amountEffectedUser",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInAccountGroup",
                        "kind": "LinkedField",
                        "name": "userInAccountGroups",
                        "plural": true,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "AccountGroupAssignmentRule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "licensesUsedByUser",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxLicenseAmount",
                        "storageKey": null
                      }
                    ],
                    "type": "SingleUserAssignmentRule",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "learnable",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v10/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CoachingOffer",
                            "kind": "LinkedField",
                            "name": "groupCoaching",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "PublishedGroupCoachingLearnable",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CoachingOffer",
                            "kind": "LinkedField",
                            "name": "oneToOneCoaching",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "PublishedOneToOneCoachingLearnable",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v18/*: any*/),
                        "type": "PublishedCourseLearnable",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v18/*: any*/),
                        "type": "PublishedMicroLearningLearnable",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "LearnableLicenseGrouping",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountMemberManagementQueries",
        "kind": "LinkedField",
        "name": "AccountMemberManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filterByGroupIds",
                "value": []
              }
            ],
            "concreteType": "AccountMembersResult",
            "kind": "LinkedField",
            "name": "AccountMembers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountMemberConnection",
                "kind": "LinkedField",
                "name": "accountMembers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountMemberEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isAccountMember"
                          },
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isManager",
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserInAccount",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserInAccountGroup",
                                    "kind": "LinkedField",
                                    "name": "groups",
                                    "plural": true,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserInAccountWrapper",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "AccountMembers(filterByGroupIds:[])"
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "UserInAccountGroupWrappersResult",
            "kind": "LinkedField",
            "name": "UserInAccountGroupWrappers",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInAccountGroupWrapperConnection",
                "kind": "LinkedField",
                "name": "userInAccountGroupWrappers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserInAccountGroupWrapperEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInAccountGroupWrapper",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "UserInAccountGroupWrappers(doCalcMemberCount:false,includeOwner:true,includeUser:true)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "accounts",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": (v9/*: any*/),
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": "extension(accountExtensionKind:\"Academies\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5ba377d63876d475cb0b6d0dc15a4a00",
    "id": null,
    "metadata": {},
    "name": "licenseDetails_Query",
    "operationKind": "query",
    "text": "query licenseDetails_Query(\n  $licenseGroupingId: ID!\n) {\n  ...licenseDetails_LicenseGroupingFragment_2p8GkE\n  ...licensesNewSingleUserAssignmentForm_QueryFragment\n  ...userRulesTab_UserQueryFragment\n  AccountMemberManagement {\n    UserInAccountGroupWrappers(includeOwner: true, includeUser: true, doCalcMemberCount: false) {\n      count\n      userInAccountGroupWrappers {\n        edges {\n          node {\n            memberCount\n            group {\n              id\n              name\n              isBuiltIn\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  Viewer {\n    Auth {\n      currentUser {\n        accounts {\n          id\n          extension(accountExtensionKind: Academies) {\n            __typename\n            kind\n            ... on AcademiesAccountExtension {\n              licenseModelKind\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment groupRulesTab_QueryFragment on AccountGroupAssignmentRule {\n  id\n}\n\nfragment licenseDetails_LicenseGroupingFragment_2p8GkE on Query {\n  LicenseGrouping {\n    LicenseGrouping(id: $licenseGroupingId) {\n      __typename\n      id\n      usedLicenseAmount\n      totalLicenseAmount\n      kind\n      ... on LearnableLicenseGrouping {\n        learnable {\n          __typename\n          kind\n          ... on PublishedGroupCoachingLearnable {\n            id\n            groupCoaching {\n              id\n              description {\n                name\n                description\n              }\n            }\n          }\n          ... on PublishedOneToOneCoachingLearnable {\n            id\n            oneToOneCoaching {\n              id\n              description {\n                name\n                description\n              }\n            }\n          }\n          ... on PublishedCourseLearnable {\n            id\n            root {\n              id\n              description\n              structureDefinition {\n                __typename\n                title\n              }\n            }\n          }\n          ... on PublishedMicroLearningLearnable {\n            id\n            root {\n              id\n              description\n              structureDefinition {\n                __typename\n                title\n              }\n            }\n          }\n          id\n        }\n      }\n      ...licensesProductCard_QueryFragment\n      assignmentRules {\n        __typename\n        ...licensesAccountGroupAssignmentCard_QueryFragment\n        ...licensesSingleUserAssignmentCard_SingleUserAssignmentRuleFragment\n        ...userRulesTab_QueryFragment\n        ...groupRulesTab_QueryFragment\n        id\n      }\n    }\n  }\n}\n\nfragment licensesAccountGroupAssignmentCard_QueryFragment on AccountGroupAssignmentRule {\n  __typename\n  id\n  name\n  active\n  licenseGroupingId\n  accountRef\n  amountEffectedUser\n  userInAccountGroups {\n    id\n    name\n    isBuiltIn\n  }\n}\n\nfragment licensesNewSingleUserAssignmentForm_AccountMemberInlineFragment on AccountMember {\n  __isAccountMember: __typename\n  id\n  name\n  kind\n  ... on UserInAccountWrapper {\n    user {\n      user {\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment licensesNewSingleUserAssignmentForm_QueryFragment on Query {\n  AccountMemberManagement {\n    AccountMembers(filterByGroupIds: []) {\n      accountMembers {\n        edges {\n          node {\n            __typename\n            ...licensesSingleUserAssignmentCard_AccountMemberFragment\n            ...licensesNewSingleUserAssignmentForm_AccountMemberInlineFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment licensesProductCard_QueryFragment on LicenseGrouping {\n  __isLicenseGrouping: __typename\n  kind\n  ... on LearnableLicenseGrouping {\n    learnable {\n      __typename\n      ... on PublishedGroupCoachingLearnable {\n        groupCoaching {\n          id\n          description {\n            contractPartner {\n              data {\n                name\n                linkToAGB\n              }\n              id\n            }\n            name\n            image {\n              thumbnail\n              id\n            }\n          }\n        }\n      }\n      ... on PublishedOneToOneCoachingLearnable {\n        oneToOneCoaching {\n          id\n          description {\n            contractPartner {\n              data {\n                name\n                linkToAGB\n              }\n              id\n            }\n            name\n            image {\n              thumbnail\n              id\n            }\n          }\n        }\n      }\n      ... on PublishedCourseLearnable {\n        id\n        root {\n          id\n          description\n          image {\n            thumbnail\n            id\n          }\n          structureDefinition {\n            __typename\n            title\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  extension {\n                    __typename\n                    ... on PublishedConstellationRootExtensionExtension {\n                      contractPartner {\n                        data {\n                          name\n                          linkToAGB\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      ... on PublishedMicroLearningLearnable {\n        id\n        root {\n          id\n          description\n          image {\n            thumbnail\n            id\n          }\n          structureDefinition {\n            __typename\n            title\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  extension {\n                    __typename\n                    ... on PublishedConstellationRootExtensionExtension {\n                      contractPartner {\n                        data {\n                          name\n                          linkToAGB\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment licensesSingleUserAssignmentCard_AccountMemberFragment on AccountMember {\n  __isAccountMember: __typename\n  id\n  name\n  isManager\n  kind\n  ... on UserInAccountWrapper {\n    user {\n      id\n      user {\n        id\n      }\n      groups {\n        id\n        name\n        isBuiltIn\n      }\n    }\n  }\n}\n\nfragment licensesSingleUserAssignmentCard_SingleUserAssignmentRuleFragment on SingleUserAssignmentRule {\n  __typename\n  id\n  userId\n  licenseGroupingId\n  licensesUsedByUser\n  maxLicenseAmount\n}\n\nfragment userRulesTab_AccountMemberInlineFragment on AccountMember {\n  __isAccountMember: __typename\n  ... on UserInAccountWrapper {\n    user {\n      user {\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment userRulesTab_QueryFragment on SingleUserAssignmentRule {\n  id\n  userId\n  licensesUsedByUser\n  maxLicenseAmount\n}\n\nfragment userRulesTab_UserQueryFragment on Query {\n  AccountMemberManagement {\n    AccountMembers(filterByGroupIds: []) {\n      accountMembers {\n        edges {\n          node {\n            __typename\n            ...licensesSingleUserAssignmentCard_AccountMemberFragment\n            ...userRulesTab_AccountMemberInlineFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "87b4538a8722c12f949efa7b67e86431";

export default node;
